import { GeneralActionTypes } from "./actionTypes";

export function getCurrencies() {
  return {
    type: GeneralActionTypes.Get_Currencies_Request,
  };
}
export function getMapData(data) {
  return {
    type: GeneralActionTypes.Map_Request,
    data,
  };
}

export function getBetSlipConfiguration(data) {
  return {
    type: GeneralActionTypes.Bet_Slip_Configuration_Request,
    data,
  };
}

export function formStatuses(data) {
  return {
    type: GeneralActionTypes.Form_Statuses_Request,
    data,
  };
}

export function pageName(data) {
  return {
    type: GeneralActionTypes.Page_Name_Request,
    data,
  };
}

export function getWebFiles() {
  return {
    type: GeneralActionTypes.Web_Files_Request,
  };
}

export function getWebFile(data) {
  return {
    type: GeneralActionTypes.Web_File_Request,
    data,
  };
}

export function createBetCode() {
  return {
    type: GeneralActionTypes.Create_Bet_Code_Request,
  };
}

export function betsByBetCode(request) {
  if (!request.id || request.id === undefined) {
    return {
      type: GeneralActionTypes.Bets_By_Bet_Code_Error,
      message: "Please enter bet code",
    };
  }
  if (request.id.length !== 6) {
    return {
      type: GeneralActionTypes.Bets_By_Bet_Code_Error,
      message: "Bet code must have 6 characters",
    };
  }
  return {
    type: GeneralActionTypes.Bets_By_Bet_Code_Request,
    request,
  };
}

export function clearBetCode() {
  return {
    type: GeneralActionTypes.Bet_Code_Clear,
  };
}

export function getCountryPhoneProviders(data) {
  return {
    type: GeneralActionTypes.Get_CountryPhone_Providers_Request,
    data,
  };
}

export function getCountries() {
  return {
    type: GeneralActionTypes.Get_Countries_Request,
  };
}

export function getCounties() {
  return {
    type: GeneralActionTypes.Get_Counties_Request,
  };
}

export function getBannerImages() {
  return {
    type: GeneralActionTypes.Get_Banners_Request,
  };
}
export function getCalenderIcons() {
  return {
    type: GeneralActionTypes.Get_Calender_Request,
  };
}

export function getFooterProviders() {
  return {
    type: GeneralActionTypes.Get_Footer_Providers_Request,
  };
}

export function getFooterText() {
  return {
    type: GeneralActionTypes.Get_Footer_Text_Request,
  };
}

export function getCountryFlagImages() {
  return {
    type: GeneralActionTypes.Get_Country_Flag_Images,
  };
}

export function getSportTypesIcons() {
  return {
    type: GeneralActionTypes.Get_Sport_Types_Icons_Request,
  };
}


export function validateCoupon(couponCode) {
  if (!couponCode.couponCode) {
    return {
      type: GeneralActionTypes.Validate_Coupon_Error,
      message: "Please enter coupon code",
    };
  }
  return {
    type: GeneralActionTypes.Validate_Coupon_Request,
    couponCode: couponCode,
  };
}

export function couponClearMessage() {
  return {
    type: GeneralActionTypes.Validate_Coupon_Clear_Message,
  };
}




export function GetLoyaltyRewardsOptions() {
  return {
    type: GeneralActionTypes.Get_Loyalty_Rewards_Options_Request,
  };
}

export function getSportPromos() {
  return {
    type: GeneralActionTypes.Get_Sport_Promos_Request,
  };
}
export function getSportPromoInfo(data) {
  return {
    type: GeneralActionTypes.Get_Sport_Promos_Info_Request,
    data
  };
}
export function resetGetSportPromos() {
  return {
    type: GeneralActionTypes.Reset_Get_Sport_Promos,
  };
}
export function resetGetSportPromoInfo() {
  return {
    type: GeneralActionTypes.Reset_Get_Sport_Promos_Info_Request,
  };
}
export function GetHeaderTabs() {
  return {
    type: GeneralActionTypes.Get_Header_Tabs_Request,
  };
}
export function ActiveSpinAndWinTable(data) {
  return {
    type: GeneralActionTypes.Active_Spin_And_Win_Table,
    data
  };
}
export function GetLuckyNumberConfiguration() {
  return {
    type: GeneralActionTypes.Get_Lucky_Number_Configuration_Request,
  };
}
export function GetLandingConfiguration() {
  return {
    type: GeneralActionTypes.Get_Landing_Configuration_Request,
  };
}
export function GetWorkWithUsConfiguration() {
  return {
    type: GeneralActionTypes.Get_Work_With_Us_Configuration_Request,
  };
}
export function GetKioskWebBannerImages(GroupId) {
  return {
    type: GeneralActionTypes.Get_Kiosk_Web_Banner_Images_Request,
    GroupId
  };
}
export function validateCouponReset() {
  return {
    type: GeneralActionTypes.Validate_Coupon_Reset,
  };
}
